export default __webpack_public_path__ + "static/media/Foto6.1cc0966d.png";